import { FC } from 'react';
import cn from 'classnames';
import styles from './OrganizationImageBlockOrganism.module.css';
import { Button, Checkbox, ValidationForm } from '../../atoms';
import { Form } from 'react-bootstrap';
import { ImageUploader, RadioSelect } from '../../molecules';
import { useNavigate, useParams } from 'react-router-dom';
import { ImageBlockResponseDto } from '../../../store/buyerAPI/block/dto/response/image-block-response.dto';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { ImageSize } from '../../../store/buyerAPI/block/dto/image-size';

interface OrganizationImageBlockOrganismProps {
  handleOnChange: (imageBlock: ImageBlockResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  handleBackgroundOnChange: (imageMeta: ImageMeta) => void;
  imageBlock: ImageBlockResponseDto;
  callbackFn: (imageBlock: ImageBlockResponseDto) => void;
}

const OrganizationImageBlockOrganism: FC<
  OrganizationImageBlockOrganismProps
> = ({
  handleOnChange,
  handleImageOnChange,
  handleBackgroundOnChange,
  imageBlock,
  callbackFn,
}) => {
  const navigate = useNavigate();
  const { organizationId } = useParams();

  const imageSizes = Object.values(ImageSize);
  const options = imageSizes.map((size) => ({
    content: size,
    value: size,
  }));

  return (
    <div className={cn(styles.imageBlockOrganismWrapper)}>
      <ValidationForm onSubmitCallback={() => callbackFn(imageBlock)}>
        <div className={cn(styles.imagesContainerWrapper)}>
          <div className={cn(styles.imageWrapper)}>
            <div className={cn(styles.labelWrapper)}>
              <Form.Label>Image</Form.Label>
            </div>
            <hr />
            <div className={cn(styles.imageUploaderWrapper)}>
              <Form.Group className="mb-3">
                <ImageUploader
                  id="image"
                  setImage={(e) =>
                    handleOnChange({ ...imageBlock, imageUrl: e })
                  }
                  setImageMeta={(imageMeta) => handleImageOnChange(imageMeta)}
                  imageSrc={imageBlock.imageUrl ?? undefined}
                />
              </Form.Group>
            </div>
          </div>
          <div className={cn(styles.imageWrapper)}>
            <div className={cn(styles.labelWrapper)}>
              <Form.Label>Background Image</Form.Label>
            </div>
            <hr />
            <div className={cn(styles.imageUploaderWrapper)}>
              <Form.Group className="mb-3">
                <ImageUploader
                  id="background-image"
                  setImage={(e) =>
                    handleOnChange({ ...imageBlock, backgroundImageUrl: e })
                  }
                  setImageMeta={(imageMeta) =>
                    handleBackgroundOnChange(imageMeta)
                  }
                  imageSrc={imageBlock.backgroundImageUrl ?? ''}
                />
              </Form.Group>
            </div>
          </div>
        </div>
        <div className={cn(styles.formWrapper)}>
          <Form.Group className="mb-3">
            <Form.Label>Background Color (use Hex Color Codes)</Form.Label>
            <Form.Control
              type="text"
              value={imageBlock.backgroundColor ?? ''}
              onChange={(e) =>
                handleOnChange({
                  ...imageBlock,
                  backgroundColor: e.target.value,
                })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Image Text</Form.Label>
            <Form.Control
              type="text"
              value={imageBlock.imageAltText ?? ''}
              onChange={(e) =>
                handleOnChange({
                  ...imageBlock,
                  imageAltText: e.target.value,
                })
              }
            />
          </Form.Group>

          <Form.Label>Image Size</Form.Label>
          <Form.Group className="mb-3">
            <RadioSelect
              options={options}
              selectedValue={imageBlock.imageSize}
              handleClick={(e) => {
                const imageSize =
                  ImageSize[e as keyof typeof ImageSize] || ImageSize.Default;
                handleOnChange({ ...imageBlock, imageSize });
              }}
            />
          </Form.Group>

          <Form.Label>With Texture</Form.Label>
          <Form.Group className="mb-3">
            <Checkbox
              checked={imageBlock.withTexture}
              onChange={(checked) => {
                handleOnChange({ ...imageBlock, withTexture: checked });
              }}
              id="with-texture"
            />
          </Form.Group>

          <Form.Label>Header</Form.Label>
          <Form.Group className="mb-3">
            <Checkbox
              checked={imageBlock.header}
              onChange={(checked) => {
                handleOnChange({ ...imageBlock, header: checked });
              }}
              id="header"
            />
          </Form.Group>
          <div className={cn(styles.buttonsWrapper)}>
            <div className={cn(styles.button)}>
              <Button variant="dark" type="submit">
                Save
              </Button>
            </div>
            <div className={cn(styles.button)}>
              <Button
                variant="dark"
                onClick={() =>
                  navigate(
                    `/organizations/edit/${organizationId}/content-blocks`
                  )
                }
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </ValidationForm>
    </div>
  );
};

export default OrganizationImageBlockOrganism;
